import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const HeaderGuideIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M12 0.25C5.52 0.25 0.25 5.52 0.25 12C0.25 18.48 5.52 23.75 12 23.75C18.48 23.75 23.75 18.48 23.75 12C23.75 5.52 18.48 0.25 12 0.25ZM12 22.25C6.35 22.25 1.75 17.65 1.75 12C1.75 6.35 6.35 1.75 12 1.75C17.65 1.75 22.25 6.35 22.25 12C22.25 17.65 17.65 22.25 12 22.25Z"
        fill={color}
      />
      <path
        d="M12.38 16H11.62C11.2776 16 11 16.2776 11 16.62V17.38C11 17.7224 11.2776 18 11.62 18H12.38C12.7224 18 13 17.7224 13 17.38V16.62C13 16.2776 12.7224 16 12.38 16Z"
        fill={color}
      />
      <path
        d="M12 6C9.72996 6 8.24996 7.3 8.02996 9.43C7.99996 9.73 8.21996 10 8.52996 10H9.52996C9.76996 10 9.99996 9.83 10.02 9.59C10.18 8.19 11.14 8 12 8C13.66 8 14 8.68 14 9.7C14 10.46 13.21 10.78 12.87 10.88C11.77 11.21 11 12.23 11 13.38V14C11 14.28 11.22 14.5 11.5 14.5H12.5C12.78 14.5 13 14.28 13 14V13.38C13 13.1 13.19 12.87 13.46 12.79C15.03 12.32 16 11.14 16 9.7C16 7.35 14.54 6 12 6Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

HeaderGuideIcon.displayName = 'HeaderGuideIcon';
